import { FC } from 'react'
import OverigeDataView from './OverigeDataView'

const OverigeDataGebiedList: FC = () => <OverigeDataView mode="gebied" />

export default OverigeDataGebiedList
